import { v4 as uuid } from 'uuid';

export interface RRITag {
  id?: uuid;
  name: string;
  description?: string;
  color?: string;
  format?: (tag: RRITag) => string;
}
